import React, { useEffect, useState } from "react";

import {
    getCoupons,
    getCouponStats,
} from "../services/adminApi";

import CouponHeader from "../components/coupons/CouponHeader";
import CouponStats from "../components/coupons/CouponStats";
import CouponFilters from "../components/coupons/CouponFilters";
import CouponTable from "../components/coupons/CouponTable";

import EmptyCoupons from "../components/coupons/EmptyCoupons";
import LoadingCoupons from "../components/coupons/LoadingCoupons";

import "../styles/Coupons.css";
import "../styles/EmptyCoupons.css";
import "../styles/LoadingCoupons.css";

const Coupons = () => {
    const [coupons, setCoupons] = useState([]);
    const [stats, setStats] = useState({});
    const [loading, setLoading] = useState(true);

    const loadCoupons = async () => {
        try {
            const [couponRes, statsRes] = await Promise.all([
                getCoupons(),
                getCouponStats(),
            ]);

            setCoupons(couponRes.data.coupons || []);
            setStats(statsRes.data.stats || {});
        } catch (err) {
            console.error("Failed to load coupons", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadCoupons();
    }, []);

    return (
        <div className="coupons-page">

            <CouponHeader />

            <CouponStats stats={stats} />

            <CouponFilters />

            {loading ? (
                <LoadingCoupons />
            ) : coupons.length === 0 ? (
                <EmptyCoupons />
            ) : (
                <CouponTable
                    coupons={coupons}
                    loading={false}
                />
            )}

        </div>
    );
};

export default Coupons;